import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { Field } from 'react-final-form';
import { useFieldValue } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

import { useTranslation } from 'Shared/contexts/TranslationsContext';
import WorkspaceForm from './WorkspaceForm/WorkspaceForm';
import './LinkExistingMeetingsFormFields.scss';
import { getRecurringMeetingsForTeammmatesWorkspaces, getRecurringMeetingsForGroupWorkspaces } from '../utils';

function LinkExistingMeetingsFormFields() {
  const { id: currentUserId } = useCurrentUser();
  const { tr } = useTranslation();
  const allRecurringMeetings = useFieldValue('recurringMeetings');
  const selectedRecurringMeetingsIds = useFieldValue('selectedRecurringMeetingsIds');

  const filteredRecurringMeetings = allRecurringMeetings.filter(({ id }) => !selectedRecurringMeetingsIds.includes(id));
  const groupRecurringMeetings = getRecurringMeetingsForGroupWorkspaces({
    recurringMeetings: filteredRecurringMeetings,
  });
  // We pass an empty array for teammatesIds because we don't want to exclude any recurring meetings
  // because of existing teammate workspaces for the link meetings step.
  const teammateRecurringMeetings = getRecurringMeetingsForTeammmatesWorkspaces({
    recurringMeetings: filteredRecurringMeetings,
    currentUserId,
    teammatesIds: [],
    highConfidence: false,
  });

  return (
    <div className="LinkExistingMeetingsFormFields d-flex flex-column">
      <div>{tr('perform.sync_meetings_flow.link_existing.intro')}</div>
      <div className="LinkExistingMeetingsFormFields__highlight-description">
        {tr('perform.sync_meetings_flow.link_existing.highlight_description')}
      </div>
      <div className="pr-3 mt-3">
        <FieldArray name="workspaces">
          {({ fields }) =>
            fields.map(name => (
              <Field
                key={name}
                name={name}
                teammateRecurringMeetings={teammateRecurringMeetings}
                groupRecurringMeetings={groupRecurringMeetings}
                component={WorkspaceForm}
              />
            ))
          }
        </FieldArray>
      </div>
    </div>
  );
}

export default LinkExistingMeetingsFormFields;
